/* hb-lp.js · Hey Bud "neck 5 reasons" landing page (sections/hb-lp-*). Loaded deferred from sections/hb-lp-footer.liquid.
   Smooth-scroll CTAs, buy-box option/plan switching, AJAX add to cart (one serum line, like the Variant B PDP),
   mobile sticky bar (state 1 = scroll to offer, state 2 = add to cart once the offer has been seen), click-to-play
   videos, and CTA events on the existing Clarity / Shopify analytics tags (no new tags). */
(function () {
  'use strict';
  var d = document;
  var hero = d.querySelector('[data-hblp-opener]');
  var opener = hero ? hero.getAttribute('data-hblp-opener') : '';
  /* hb_lp page tag (CRO briefs 02/04: Triple Whale split by hb_lp). The page's own value comes from body[data-hblp-page]
     (set server-side by the proof / guide / offer sections), else 5 Reasons = 'neck5r_' + opener (a/b/c/d).
     The ad's ?hb_lp= URL value is kept separately (hb_lp_ad), lowercase [a-z0-9_] only. The URL is never rewritten. */
  var hbLp = (d.body.getAttribute('data-hblp-page') || '') || (/^[a-d]$/.test(opener) ? 'neck5r_' + opener : '');
  if (hbLp && !d.body.getAttribute('data-hblp-page')) d.body.setAttribute('data-hblp-page', hbLp);
  var hbLpAd = '';
  try { hbLpAd = (new URLSearchParams(location.search).get('hb_lp') || '').toLowerCase(); } catch (e) {}
  if (!/^[a-z0-9_]{1,64}$/.test(hbLpAd)) hbLpAd = ''; /* 12 Oct: 64, same rule as hb-np2.js and the Trudi A/B snippet */
  if (hbLp) d.documentElement.setAttribute('data-hb-lp', hbLp);
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function track(section) {
    try { if (typeof window.clarity === 'function') window.clarity('event', 'lp_cta_' + section); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish('hb_lp_cta_click', { opener: opener, section: section, hb_lp: hbLp, hb_lp_ad: hbLpAd }); } catch (e) {}
  }
  try { if (typeof window.clarity === 'function' && opener) window.clarity('set', 'lp_opener', opener); } catch (e) {}
  try { if (typeof window.clarity === 'function' && hbLp) window.clarity('set', 'hb_lp', hbLp); } catch (e) {}

  /* ---- smooth scroll + CTA tracking ---- */
  d.addEventListener('click', function (e) {
    var cta = e.target.closest('[data-hblp-cta]');
    if (cta) track(cta.getAttribute('data-hblp-cta'));
    var a = e.target.closest('a[data-hblp-scroll]');
    if (!a) return;
    var id = (a.getAttribute('href') || '').replace(/^#/, '');
    var t = id && d.getElementById(id);
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', '#' + id);
  });

  /* ---- click-to-play videos (preload="none", nothing downloads before a tap) ----
     9 Oct fix: the play overlay hides while playing on every card type (.hblp-vcard and the proof page's .hbnp-vid), a
     tap/click on the video toggles pause/play, and the overlay comes back on pause or end (class is-paused; CSS in
     snippets/hb-lp-styles). No native controls: on touch their first tap only reveals the bar (so a tap never paused),
     and on desktop a native click-toggle would fire on top of ours. playsinline stays on for iOS. */
  d.querySelectorAll('[data-hblp-video]').forEach(function (card) {
    var v = card.querySelector('video'), b = card.querySelector('.hblp-vcard__play');
    if (!v || !b) return;
    v.controls = false;
    v.setAttribute('playsinline', ''); v.playsInline = true;
    function start() {
      d.querySelectorAll('[data-hblp-video] video').forEach(function (o) { if (o !== v && !o.paused) o.pause(); });
      card.classList.add('is-playing');
      card.classList.remove('is-paused');
      v.setAttribute('tabindex', '0');
      var p = v.play();
      if (p && p.catch) p.catch(function () { card.classList.add('is-paused'); });
    }
    function toggle() { if (v.paused || v.ended) start(); else v.pause(); }
    b.addEventListener('click', function () {
      var first = !card.classList.contains('is-playing');
      start();
      try { v.focus({ preventScroll: true }); } catch (e) {}
      if (first) track('video');
    });
    v.addEventListener('click', function (e) { if (!card.classList.contains('is-playing')) return; e.preventDefault(); toggle(); });
    v.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Enter' || e.key === 'k') { e.preventDefault(); toggle(); } });
    v.addEventListener('play', function () { card.classList.add('is-playing'); card.classList.remove('is-paused'); });
    v.addEventListener('pause', function () { if (card.classList.contains('is-playing')) card.classList.add('is-paused'); });
    v.addEventListener('ended', function () { card.classList.add('is-paused'); });
  });

  /* ---- reviews: cap the Loox widget height on long pages, expand on tap ---- */
  var rwrap = d.querySelector('[data-hblp-reviews-wrap]'), rmore = d.querySelector('[data-hblp-reviews-more]');
  if (rwrap && rmore) {
    var capPx = function () { return parseFloat(getComputedStyle(rwrap).maxHeight) || 0; };
    var checkCap = function () {
      if (rwrap.classList.contains('is-open')) return;
      rwrap.classList.add('is-capped');
      var tall = rwrap.scrollHeight > capPx() + 40;
      rwrap.classList.toggle('is-capped', tall);
      rmore.hidden = !tall;
    };
    rmore.addEventListener('click', function () {
      rwrap.classList.remove('is-capped'); rwrap.classList.add('is-open');
      rmore.hidden = true; rmore.setAttribute('aria-expanded', 'true'); track('reviews_more');
    });
    if ('ResizeObserver' in window) new ResizeObserver(checkCap).observe(rwrap); else window.addEventListener('load', checkCap);
  }

  /* ---- final CTA without a buy box: scroll instead of submitting nothing ---- */
  if (!d.getElementById('hbLpBuy')) {
    d.querySelectorAll('button[form="hbLpBuy"]').forEach(function (b) { b.type = 'button'; b.addEventListener('click', function () { var o = d.getElementById('offer'); if (o) o.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' }); }); });
  }

  /* ---- buy box ---- */
  var form = d.getElementById('hbLpBuy');
  var offer = d.querySelector('[data-hblp-offer]');
  if (!form || !offer) return;
  var planInput = form.querySelector('[data-hblp-plan-input]');
  var one = offer.getAttribute('data-one');
  var shortName = offer.getAttribute('data-short') || '';
  var opts = form.querySelectorAll('[data-hblp-opt]');
  var bnpl = form.querySelector('[data-hblp-bnpl]');
  var sticky = d.querySelector('[data-hblp-sticky]');
  /* express checkout (payment_button) skips the AJAX path below, so it gets the tag as a hidden line property
     (underscore = not shown to the customer). The AJAX add builds its own item and never reads this input. */
  if (hbLp && !form.querySelector('input[name="properties[_hb_lp]"]')) {
    var hbIn = d.createElement('input'); hbIn.type = 'hidden'; hbIn.name = 'properties[_hb_lp]'; hbIn.value = hbLp; form.appendChild(hbIn);
  }

  function cap(n) { return n.charAt(0).toUpperCase() + n.slice(1).toLowerCase(); }
  /* "Delivery Every 4 Weeks" -> "every 4 weeks" (same as the cadence field in snippets/hb-lp-data) */
  function cad(n) { return String(n || '').toLowerCase().replace('delivery ', '').trim(); }
  function current() {
    var mode = (form.querySelector('input[name="hblp_purchase"]:checked') || {}).value || 'one';
    var plan = form.querySelector('input[name="hblp_plan"]:checked');
    return {
      sub: mode === 'sub' && !!plan,
      planId: plan ? plan.value : '',
      planName: plan ? cap(plan.getAttribute('data-name') || '') : '',
      price: mode === 'sub' && plan ? plan.getAttribute('data-price') : one
    };
  }

  function render() {
    var c = current();
    if (planInput) planInput.value = c.sub ? c.planId : '';
    opts.forEach(function (o) {
      var r = o.querySelector('input[name="hblp_purchase"]');
      o.classList.toggle('is-selected', !!(r && r.checked));
    });
    var plan = form.querySelector('input[name="hblp_plan"]:checked');
    if (plan) {
      d.querySelectorAll('[data-hblp-sub-price]').forEach(function (el) { el.textContent = plan.getAttribute('data-price'); });
      d.querySelectorAll('[data-hblp-plan-name]').forEach(function (el) {
        var n = plan.getAttribute('data-name') || '';
        var m = el.getAttribute('data-hblp-plan-name');
        el.textContent = m === 'lc' ? n.toLowerCase() : m === 'cap' ? n.charAt(0).toUpperCase() + n.slice(1).toLowerCase() : m === 'cad' ? cad(n) : n;
      });
      var oneC = Number(offer.getAttribute('data-one-cents')), planC = Number(plan.getAttribute('data-cents'));
      var save = form.querySelector('.hblp-save');
      if (save && oneC > 0 && planC >= 0) { var pct = Math.round((oneC - planC) * 100 / oneC); if (save.getAttribute('data-mode') === 'amount') { /* RUN I: 'Save $20' = one-time − subscription, currency symbol from the plan price */ var sym = String(plan.getAttribute('data-price') || '$').replace(/[\d.,\s]/g, '') || '$'; var amt = (oneC - planC) / 100; save.textContent = ((save.getAttribute('data-prefix') || 'Save') + ' ' + sym + (amt % 1 ? amt.toFixed(2) : amt)).trim(); if (pct <= 0) save.hidden = true; } else { save.textContent = ((save.getAttribute('data-prefix') || '') + ' ' + pct + '%').trim(); save.hidden = pct <= 0; } }
    }
    var note = form.querySelector('[data-hblp-subnote]');
    if (note) note.hidden = !c.sub;
    d.querySelectorAll('[data-hblp-mode-line]').forEach(function (el) {
      el.textContent = c.sub ? 'Subscription · ' + c.planName + ' · renews automatically until you pause or cancel' : 'One-time purchase · no subscription';
    });
    d.querySelectorAll('[data-hblp-price]').forEach(function (el) { el.textContent = c.price; });
    /* CTA labels that promise the (Subscribe-only) gifts switch to their one-time wording (data-hblp-lbl-one, set per section) */
    d.querySelectorAll('[data-hblp-lbl-one]').forEach(function (el) { el.textContent = c.sub ? el.getAttribute('data-hblp-lbl-sub') : el.getAttribute('data-hblp-lbl-one'); });
    d.querySelectorAll('[data-hblp-was]').forEach(function (el) { el.hidden = !c.sub; });
    if (bnpl) bnpl.hidden = c.sub;
    if (sticky) {
      var t = sticky.querySelector('[data-hblp-sticky-title]'), s = sticky.querySelector('[data-hblp-sticky-sub]');
      if (t) t.textContent = c.sub ? (offer.getAttribute('data-st-sub') || shortName) : (offer.getAttribute('data-st-one') || shortName);
      if (s) { var pre = offer.getAttribute('data-st-subpre'); s.textContent = c.sub ? (pre ? pre + '\u00a0\u00b7 ' + c.price + '\u00a0' + cad(c.planName).replace(/ /g, '\u00a0') : c.price + ' ' + cad(c.planName)) : c.price + ' one-off'; }
    }
  }

  form.addEventListener('change', function (e) {
    if (e.target.name === 'hblp_plan') {
      var sub = form.querySelector('input[name="hblp_purchase"][value="sub"]');
      if (sub) sub.checked = true;
    }
    render();
  });
  /* the whole option card is clickable, not only its label row */
  opts.forEach(function (o) {
    o.addEventListener('click', function (e) {
      if (e.target.closest('label, input, a, button')) return;
      var r = o.querySelector('input[name="hblp_purchase"]');
      if (r && !r.checked) { r.checked = true; render(); }
    });
  });
  render();

  /* ---- add to cart ---- */
  var busy = false;
  var msg = form.querySelector('[data-hblp-msg]');
  function buttons() { return d.querySelectorAll('#hblpMainCta, button[form="hbLpBuy"]'); }
  function setBusy(on) {
    buttons().forEach(function (b) {
      b.classList.toggle('is-loading', on);
      if (on) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled');
      b.setAttribute('aria-busy', String(on));
    });
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) });
  }
  /* Keep the serum a single cart line, like the Variant B PDP, but add first and only then drop older serum lines,
     so a failed add never removes what the customer already had.
     12 Oct 2026 (same fix as hb-np2.js): "older serum lines" now also covers OTHER neck-serum products/variants (e.g. a
     one-time $40 collagen-hemp-neck-firming-serum line left from an earlier PDP visit), not just this offer's own
     variant, so the cart holds exactly the option chosen here. Gift lines (_gift / _offer_gift, or $0) are never touched. */
  /* Review fixes (12 Oct, same as hb-np2.js): serum products matched by product ID, not handle (L2); never touched:
     $0 lines (checked first, L1), gift lines (_gift / _offer_gift), offer-gift qualifiers (_gift_offer, whose gifts
     hb-cart.js would drop with them, M3) and lines with bundle properties. */
  var SERUM_PIDS = [
    8371340148907, /* collagen-hemp-neck-firming-serum (base) */
    8825842598059, /* collagen-hemp-neck-firming-serum-2 */
    9047599415467, /* collagen-hemp-neck-firming-serum-3 (Variant B) */
    8754849054891, /* neck-firming-60-day-supply */
    8752296853675, /* neck-firming-90-day-supply */
    8751540928683, /* collagen-hemp-neck-firming-serum-factor */
    8825895092395  /* collagen-hemp-neck-firming-serum-no-subscription */
  ];
  function isOldSerum(li, id) {
    var pr = li.properties || {};
    if (!(li.final_line_price > 0)) return false;
    if (pr._gift === 'true' || pr._offer_gift || pr._gift_offer) return false;
    if (Object.keys(pr).some(function (k) { return /bundle/i.test(k); })) return false;
    return li.variant_id === id || SERUM_PIDS.indexOf(li.product_id) > -1;
  }
  function addSingleton(item) {
    return fetch('/cart.js?_=' + Date.now(), { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
      var old = (cart.items || []).filter(function (li) { return isOldSerum(li, item.id); });
      return post('/cart/add.js', { items: [item] }).then(function (r) { return r.json(); }).then(function (res) {
        if (res && res.status) { var se = new Error(res.description || res.message || ''); se.userFacing = true; throw se; }
        var newKey = res.items && res.items[0] && res.items[0].key, updates = {}, n = 0;
        old.forEach(function (li) { updates[li.key] = li.key === newKey ? 1 : 0; n++; });
        if (newKey && !(newKey in updates) && res.items[0].quantity > 1) { updates[newKey] = 1; n++; }
        if (!n) return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); });
        /* M1: a failed cleanup (HTTP error, {status} body or network) is not success; the add did happen, so flag it */
        return post('/cart/update.js', { updates: updates })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok || (j && j.status)) throw new Error('cleanup'); return j; }); })
          .catch(function () { var ce = new Error('cleanup'); ce.added = true; throw ce; });
      });
    });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (busy) return;
    busy = true;
    if (msg) msg.textContent = '';
    setBusy(true);
    render();
    var c = current();
    var variantId = Number(form.elements.id.value);
    var item = { id: variantId, quantity: 1 };
    if (c.sub && c.planId) item.selling_plan = Number(c.planId);
    /* 12 Oct 2026: send the hidden _hb_lp line property (page tag) in the AJAX add itself. The form's hidden
       properties[_hb_lp] input was never read by this JSON add, so lines had no _hb_lp. Tracking only, nothing visible. */
    if (hbLp) item.properties = { _hb_lp: hbLp };
    var drawer = d.querySelector('cart-drawer');
    var trigger = e.submitter || null;
    function openCart() {
      /* Dawn declares PUB_SUB_EVENTS / publish as top-level bindings, not window properties */
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        /* same payload as the neck PDPs (no cartData): hb-cart.js re-reads /cart.js and draws the "Free gifts included" card */
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hb-lp', productVariantId: variantId });
      }
      if (drawer && typeof drawer.open === 'function') { drawer.classList.remove('is-empty'); drawer.open(trigger || undefined); }
      else window.location.href = '/cart';
    }
    /* clear the BYO-bundle attribute so the bundle discount never applies to this serum (same as the neck PDPs) */
    /* same request also stamps the hb_lp cart attributes (order "Additional details" / note_attributes) for attribution */
    var attrs = { bundle_source: '' };
    if (hbLp) { attrs.hb_lp = hbLp; attrs.hb_lp_ad = hbLpAd; }
    post('/cart/update.js', { attributes: attrs }).catch(function () {})
      .then(function () { return addSingleton(item); })
      .then(openCart)
      .catch(function (err) {
        /* the add worked but removing the older line failed: show the real cart (the shopper can fix it there), no error */
        if (err && err.added) { try { openCart(); } catch (x) { window.location.href = '/cart'; } return; }
        if (msg) {
          msg.textContent = (err && err.userFacing && err.message) || 'Sorry, something went wrong. Please try again.';
          if (trigger && trigger.id !== 'hblpMainCta') offer.scrollIntoView({ block: 'center' });
        }
      })
      .then(function () { busy = false; setBusy(false); });
  });

  /* ---- chat launcher (Richpanel, rp-micro-app-*): keep its bubble off the price line, CTAs and sticky bar ----
     The app sets bottom/right inline with !important, so it is lifted with a transform (CSS var --hblp-chat-lift,
     snippets/hb-lp-styles). The app is not hidden or disabled. */
  var chatLift = 0, chatRaf = 0;
  function guarded() {
    var out = [];
    d.querySelectorAll('.hbnp-hero .hbnp-vid__q, .hbnp-hero .hbnp-chip, .hblp-hero .hblp-chip, .hblp-hero .hblp-btn, .hblp-hero__gtee, #hblpMainCta, .hblp-final .hblp-btn, .hblp-buy .hblp-express').forEach(function (el) { out.push(el.getBoundingClientRect()); });
    if (sticky && !sticky.hidden && !sticky.classList.contains('is-hidden')) out.push(sticky.getBoundingClientRect());
    return out;
  }
  function placeChat() {
    chatRaf = 0;
    var icon = d.querySelector('.richpanel-micro .rp-micro-app-dummy-icon');
    if (!icon) return;
    var r = icon.getBoundingClientRect();
    if (!r.width) return;
    /* base position = current box minus the translate actually applied right now (correct even mid-transition) */
    var ty = 0, cont = icon.closest('.rp-micro-app-dummy-icon-container');
    if (cont) { var tf = getComputedStyle(cont).transform; if (tf && tf !== 'none') { var mm = tf.match(/matrix(3d)?\(([^)]+)\)/); if (mm) { var v = mm[2].split(','); ty = parseFloat(mm[1] ? v[13] : v[5]) || 0; } } }
    var top0 = r.top - ty, h = r.height, vh = window.innerHeight, rects = guarded(), lift = 0;
    /* gap kept around guarded boxes: 6px, or the page's --hblp-chat-pad (the proof pages use 10px) */
    var pad = parseFloat(getComputedStyle(d.body).getPropertyValue('--hblp-chat-pad')) || 6;
    function hits(l) { var t = top0 - l, b = t + h; return rects.some(function (g) { return g.width && g.bottom > t - pad && g.top < b + pad && g.right > r.left - pad && g.left < r.right + pad; }); }
    /* prefer a small nudge DOWN (to just above the screen edge) before lifting it up over the content */
    var maxDown = Math.max(0, Math.floor(vh - (top0 + h) - 4)), down = 0;
    if (hits(0)) { for (var dl = 4; dl <= maxDown; dl += 4) { if (!hits(-dl)) { down = dl; break; } } }
    if (down) lift = -down;
    else { while (lift < vh * 0.6 && hits(lift)) lift += 8; if (lift >= vh * 0.6) lift = 0; }
    if (lift !== chatLift) { chatLift = lift; d.documentElement.style.setProperty('--hblp-chat-lift', lift + 'px'); }
  }
  function queueChat() { if (!chatRaf) chatRaf = requestAnimationFrame(placeChat); }
  window.addEventListener('scroll', queueChat, { passive: true });
  window.addEventListener('resize', queueChat);
  if ('MutationObserver' in window) {
    var chatMo = new MutationObserver(function () { if (d.querySelector('.richpanel-micro .rp-micro-app-dummy-icon')) queueChat(); });
    chatMo.observe(d.body, { childList: true, subtree: false });
    setTimeout(function () { chatMo.disconnect(); }, 30000);
  }
  [1000, 3000, 6000, 10000].forEach(function (t) { setTimeout(queueChat, t); });

  /* ---- sticky bar (<1024px) ---- */
  if (!sticky || !('IntersectionObserver' in window)) return;
  var mq = window.matchMedia('(min-width: 1024px)');
  /* Opus r2 review must-fix 2: state 1 ("See the offer →", scrolls to #offer) until the offer section has been on screen at
     least once, then state 2 (add to cart). Hidden whenever any part of the offer section, the final CTA or the hero CTA is on
     screen, so there are never two add-to-cart buttons at once and the bar never covers the options. */
  var seenOffer = false, offerVis = false, finalVis = false, heroCta = true;
  var see = sticky.querySelector('[data-hblp-sticky-see]'), add = sticky.querySelector('[data-hblp-sticky-add]');
  function updSticky() {
    if (mq.matches) { sticky.hidden = true; return; }
    sticky.hidden = false;
    if (see) see.hidden = seenOffer;
    if (add) add.hidden = !seenOffer;
    var hide = offerVis || finalVis || heroCta;
    sticky.classList.toggle('is-hidden', hide);
    sticky.setAttribute('data-state', seenOffer ? 'add' : 'see');
    if ('inert' in sticky) sticky.inert = hide; else sticky.setAttribute('aria-hidden', String(hide));
    setTimeout(queueChat, 300); setTimeout(queueChat, 700);
  }
  sticky.addEventListener('transitionend', queueChat);
  var offerSec = offer.closest('section') || offer;
  new IntersectionObserver(function (en) {
    en.forEach(function (x) { offerVis = x.isIntersecting; if (x.isIntersecting) seenOffer = true; });
    updSticky();
  }, { threshold: 0 }).observe(offerSec);
  var finalSec = d.querySelector('.hblp-final');
  if (finalSec) new IntersectionObserver(function (en) {
    en.forEach(function (x) { finalVis = x.isIntersecting; });
    updSticky();
  }, { threshold: 0 }).observe(finalSec);
  var heroBtn = d.querySelector('.hblp-hero .hblp-btn');
  if (heroBtn) new IntersectionObserver(function (en) {
    en.forEach(function (x) { heroCta = x.isIntersecting || x.boundingClientRect.top > 0; });
    updSticky();
  }, { threshold: 0 }).observe(heroBtn); else heroCta = false;
  if (mq.addEventListener) mq.addEventListener('change', updSticky);
  /* never sit over the cart drawer */
  var drawerEl = d.querySelector('cart-drawer');
  if (drawerEl && 'MutationObserver' in window) {
    new MutationObserver(function () {
      d.body.classList.toggle('hblp-drawer-open', drawerEl.classList.contains('active') || drawerEl.hasAttribute('open'));
    }).observe(drawerEl, { attributes: true, attributeFilter: ['class', 'open'] });
  }
  updSticky();
})();
